import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { contactData } from './contact-data';

import './Contacts.css';

export default class Contacts extends Component {
  state = {
    contacts: []
  };

  componentDidMount() {
    this.getContacts();
  }

  getContacts = () => {
    // axios(`/api/region-contacts`).then(res => {
    // });
    this.setState({ contacts: contactData });
  };

  hover = (e) => {
    e.target.setAttribute('src', 'https://image.flaticon.com/icons/svg/34/34196.svg')
  }

  unhover = (e) => {
    e.target.setAttribute('src', 'https://image.flaticon.com/icons/svg/263/263093.svg')   
  }

  contacts = val => {
    return val && val.map(e => {
      return (
        <div className="contacts_sub_container" key={e.id}>
          <div className="contacts_top">
            <h1 className="cont_name">{e.name}</h1>
            {e.position && (

            <h2>{e.position}</h2>
            )}
          </div>
          <div className="cont_dropdown">
            {e.schoolPosition && (
            <h2>{e.schoolPosition}</h2>
            )}
            <h2>{e.school}</h2>
            <h2>{e.email}</h2>
            {e.phone && (
            <h2>{e.phone}</h2>
            )}
            <div className="">
              <a className="" href={'mailto:' + e.email}>
                <img
                  src="https://svgsilh.com/svg_v2/147563.svg"
                  alt="Email Icon"
                  className='email_icon'
                  // onMouseOver={this.hover}
                  // onMouseOut={this.unhover}
                />
              </a>
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    const { contacts } = this.state;

    return (
      <div className="contacts_page">
        <div className="component_img" />

        <h1 className="contacts_title">Region 20 Officers</h1>
        <div className="contacts_container">{this.contacts(contacts[0])}</div>
        <h1 className="contacts_title">Region 20 Executive Committee</h1>
        <div className="contacts_container">{this.contacts(contacts[1])}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Contacts/Contacts.js